import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';
import type { GemmaAdvice } from '../types';

const DEFAULT_ADVICE: GemmaAdvice = {
  tips: [],
  wastePotentialYearly: 0,
};

export function useGemmaAdvice(enabled = true) {
  const { user, session } = useAuth();
  const [advice, setAdvice] = useState<GemmaAdvice>(DEFAULT_ADVICE);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAdvice = useCallback(async () => {
    if (!enabled || !user) return;
    setLoading(true);
    setError(null);

    try {
      const { data, error: fnError } = await supabase.functions.invoke('gemma-advice', {
        headers: session?.access_token
          ? { Authorization: `Bearer ${session.access_token}` }
          : undefined,
      });

      if (fnError) throw fnError;

      setAdvice({
        tips: Array.isArray(data?.tips) ? data.tips : [],
        wastePotentialYearly: Number(data?.wastePotentialYearly) || 0,
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch AI advice');
    } finally {
      setLoading(false);
    }
  }, [enabled, user, session]);

  useEffect(() => {
    fetchAdvice();
  }, [fetchAdvice]);

  return { advice, loading, error, refetch: fetchAdvice };
}
